'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'hexagon-nodes';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e699';
var svgPathData = ['M32 210.6c15.6 7.4 33.2 7 48 0l0 90.8c-14.8-7-32.4-7.4-48 0l0-90.8zM88 206c6.5-4.6 12.2-10.6 16.5-17.9c4.3-7.5 6.7-15.6 7.4-23.7L192 210.1c-13.4 9.4-22.5 24.4-23.8 41.7L88 206zm0 100.1l80.1-45.8c1.3 17.3 10.4 32.3 23.8 41.7l-80.1 45.8c-.6-8.1-3-16.2-7.4-23.7c-4.3-7.4-9.9-13.4-16.5-18zM200 106.6c7.3 3.5 15.4 5.4 24 5.4s16.7-1.9 24-5.4l0 98.8c-7.3-3.5-15.4-5.4-24-5.4s-16.7 1.9-24 5.4l0-98.8zm0 200c7.3 3.5 15.4 5.4 24 5.4s16.7-1.9 24-5.4l0 98.8c-7.3-3.5-15.4-5.4-24-5.4s-16.7 1.9-24 5.4l0-98.8zm56-96.6l80.1-45.8c.6 8.1 3 16.2 7.4 23.7c4.2 7.4 9.9 13.4 16.5 17.9l-80.1 45.8c-1.3-17.3-10.4-32.3-23.8-41.7zm0 91.9c13.4-9.4 22.5-24.4 23.8-41.7L360 306.1c-6.5 4.6-12.2 10.6-16.5 18c-4.3 7.5-6.7 15.6-7.4 23.7L256 301.9zm112-91.3c14.8 7 32.4 7.4 48 0l0 90.8c-15.6-7.4-33.2-7-48 0l0-90.8z', 'M168 56a56 56 0 1 1 112 0A56 56 0 1 1 168 56zm196 55.5a56 56 0 1 1 56 97 56 56 0 1 1 -56-97zM7.5 132a56 56 0 1 1 97 56 56 56 0 1 1 -97-56zM168 456a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM104.5 324a56 56 0 1 1 -97 56 56 56 0 1 1 97-56zM364 400.5a56 56 0 1 1 56-97 56 56 0 1 1 -56 97zM224 200a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHexagonNodes = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;